import { lazyPage } from '@/lib/lazy-load'

const BillingPlansPage = lazyPage(() => import('./BillingPlansPage'))
export default BillingPlansPage
